<p>exam-category-details works!</p>
